import type { Building } from "building-types/building/buildingTypes";

/** Selects a stage's declared Building dependencies while preserving their references. */
export default function makeBuildingSelector<K extends keyof Building>(
  keys: readonly K[],
): (building: Pick<Building, K>) => Pick<Building, K> {
  return (building: Pick<Building, K>): Pick<Building, K> => {
    const selected: Pick<Building, K> = {} as Pick<Building, K>;
    for (const key of keys) {
      selected[key] = building[key];
    }
    return selected;
  };
}
